export type LanguageCode = "en" | "es";

export interface Language {
  code: LanguageCode;
  label: string;
}

export const supportedLanguages: Language[] = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];
